// From https://stackoverflow.com/a/2901298
export default function numberWithCommas(x) {
	if (!x) {
		return x;
	}
	let parts = x.toString().split('.');
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	return parts.join('.');
}
